import QuestionMarkIcon from "./QuestionMark";
import NivaBupaIcon from "./NivaBupa";
import ClaimsIcon from "./Claims";
import CashlessIcon from "./Cashless";
import ThirtyIcon from "./Thirty";
import TrustedIcon from "./Trusted";
import RelationshipIcon from "./Relationship";
import FamilyIcon from "./Family";
import RightArrowIcon from "./RightArrow";
import TickMark from "./TickMark";
import LeftArrowIcon from "./LeftArrow";
import ChevronDown from "./ChevronDown";
import StarIcon from "./Star";
import CrossMark from "./CrossMark";
import SearchIcon from "./Search";
export {
  QuestionMarkIcon,
  NivaBupaIcon,
  ClaimsIcon,
  CashlessIcon,
  ThirtyIcon,
  TrustedIcon,
  RelationshipIcon,
  FamilyIcon,
  RightArrowIcon,
  TickMark,
  LeftArrowIcon,
  ChevronDown,
  StarIcon,
  CrossMark,
  SearchIcon,
};
